// extracted by mini-css-extract-plugin
export default {"wrap":"LG-z","fullWidth":"MG-z","hideOnDesktop":"NG-z","content":"OG-z","hasOpenedNav":"PG-z","crumbsList":"QG-z","dropdownsWrap":"RG-z"};